export enum OtpPhase {
  /** Initial phase when a valid prefill email is present; shows a spinner while auto-sending the passcode. */
  AutoSending = 'autoSending',
  /** Email input form is displayed for the user to enter or correct their email address for fallback or in case of error */
  EmailInput = 'emailInput',
  /** Passcode was sent successfully; shows the OTP challenge form for the user to enter the code. */
  OtpReady = 'otpReady',
}
